import React, { useEffect } from 'react'

const eventsTypes = ['click'] as const

export const useOutsideClick = (
  listening: boolean,
  setListening: React.Dispatch<React.SetStateAction<boolean>>,
  menuRef: React.RefObject<HTMLElement>,
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>,
) => {
  useEffect(() => {
    if (listening || !menuRef.current) return

    const handleClickOutside: EventListener = (evt: Event) => {
      if (menuRef.current && menuRef.current.contains(evt.target as Node))
        return
      setIsOpen(false)
    }

    eventsTypes.forEach((type) => {
      document.addEventListener(type, handleClickOutside)
    })

    return () => {
      eventsTypes.forEach((type) => {
        document.removeEventListener(type, handleClickOutside)
      })
    }
  }, [listening, menuRef, setIsOpen, setListening])
}
